const Component = () => import('./DeliveryForm');

export { Component };
